import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-[#1F2937] py-9">
      <div className="container flex lg:flex-row gap-3 flex-col justify-between sm:items-center">
        <p className="text-white text-xl font-medium">
          {t("footer_copyright")}
        </p>

        <div className="flex sm:flex-row flex-col sm:gap-10 gap-3">
          <p className="text-white text-xl font-medium">{t("footer_privacy_policy")}</p>

          <div className="border-s border-white"></div>

          <p className="text-white text-xl font-medium">{t("footer_terms")}</p>

          <div className="border-s border-white"></div>

          <p className="text-white text-xl font-medium">{t("footer_legal")}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
